const env = {}
function initEnv () {
  return {
    set: (id, opts) => {
      env[id] = opts
    },
    get: (id) => {
      return env[id] || {}
    }
  }
}

export default initEnv()
